import React, { useEffect, useState } from 'react';
import { useNavigate  , useSearchParams } from "react-router-dom";

import {SvgOk} from '../Svg.js';

  
function FormUsuarioModulo() {
    const navigate = useNavigate(); // Inicialize o hook


    const [formData, setFormData] = useState({
        login: false,
        retaguarda: false,
        adm: false,
        pdv: false,
        emissoresFiscais: false,
        complementos: false,
        totens: false,
        controles: false,
    });



    const handleChange = (event) => {
        const { name, checked } = event.target;
        setFormData({
          ...formData,
          [name]: checked,
        });
      };

  const handleSubmit = async (e) => {
    e.preventDefault();
    //alert('indo 1');
    const params = new URLSearchParams();
    for (const key in formData) {
            if (key === "Situacao")  {
        if (formData[key] === "") {
          formData[key] = "Ativo"; }};
        //alert(key+ formData[key]);
        params.append(key, formData[key]);
    }
    console.log('params----->', params, formData);
    //alert('indo 2');
    navigate('/FormUsu');
    const response = await fetch('http://www.criar.com.br:3000/UsuarioModulosAltera', {
      method: "POST",
      headers: {"Content-Type": "application/json", },
      body: JSON.stringify(formData),
    });
    console.log(response);
  };

  const [searchParams] = useSearchParams();
  const id = searchParams.get("id"); 
  formData.Id = id;
  useEffect(() => {
    fetch(`http://www.criar.com.br:3000/UsuarioModulosAltera?id=${id}`)
      .then(response => response.text()
      )
      .then(data => {
        //alert('Data1 '+data);
        data = JSON.parse(data);
        //alert('Data2 '+data);
        const modulo = data.modulos; 
        //alert('modulo '+modulo);
        //const primeiraPosicao = modulo.charAt(1); // ou modulo[1]
        //alert(primeiraPosicao);
        
          setFormData(prevState => ({
            ...prevState, 
            login :  (modulo.charAt(7) === '1'),
            retaguarda :  (modulo.charAt(0) === '1'),
            adm: (modulo.charAt(1) === '1'),
            pdv: (modulo.charAt(2) === '1'),
            emissoresFiscais: (modulo.charAt(3) === '1'),
            complementos: (modulo.charAt(4) === '1'),
            totens: (modulo.charAt(5) === '1'),
            controles: (modulo.charAt(6) === '1')
            
                
          }));
        


      })
      .catch(error => console.error(error));
  }, [id]);
  
  
   return (

<div class="areabox">
	
	<h1>Usuário</h1>
		<div class='row'>
		<div class='col-p'>
			<div class='card1'>
			</div>
		</div>
		<div class='col-4'>
			<div class='card1'>
				<h2>Modulos</h2>
                <div id = "texto"> 
                    <form onSubmit={handleSubmit}>


<div> <label> <input type="checkbox" name="login" checked={formData.login} onChange={handleChange}/> Login </label></div>
<div> <label> <input type="checkbox" name="retaguarda" checked={formData.retaguarda} onChange={handleChange}/> Retaguarda </label></div>
<div> <label> <input type="checkbox" name="adm" checked={formData.adm} onChange={handleChange} /> Adm </label> </div>
<div> <label> <input type="checkbox" name="pdv" checked={formData.pdv} onChange={handleChange} /> PDV </label> </div>
<div> <label> <input type="checkbox" name="emissoresFiscais" checked={formData.emissoresFiscais} onChange={handleChange} /> Emissores Fiscais </label> </div>
<div> <label> <input type="checkbox" name="complementos" checked={formData.complementos} onChange={handleChange} /> Complementos </label> </div> 
<div> <label> <input type="checkbox" name="totens" checked={formData.totens} onChange={handleChange} /> Totens </label> </div>
<div> <label> <input type="checkbox" name="controles" checked={formData.controles} onChange={handleChange} /> Controles </label></div>

                    <br/>
                    <br/>
                    <button type="submit" class="botaocinsa"><SvgOk/><br/>Alterar</button><br/><br/>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>



  );
}

export default FormUsuarioModulo;